import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { FormService } from '@app/services/form.service';
import { IpService } from '@app/services/ip.service';
import { Console } from 'console';

@Component({
  selector: 'reactive-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss', './general.css'],
})

export class FormComponent implements OnInit {
  form: FormGroup;
  domain: string = "JELPIT";
  secondChannel: string = "";
  options = [
    { value: 'seguros-bolivar', label: 'Seguros Bolivar', class: 'seguros-bolivar' },
    { value: 'ciencuadras', label: 'Ciencuadras', class: 'ciencuadras' },
    { value: 'jelpit', label: 'Jelpit', class: 'jelpit' },
    { value: 'doctoraki', label: 'Doctor Aki', class: 'doctoraki' }
  ];

  public headerIconClass: any;
  public imagenUrl: string;

  /**
   * Custom classes
  */
  public customClass: string;
  public customErrorNotificaction: string;
  public customSaveNotification: string;
  public customAuth: string;

  public lineBusiness: number;
  public company: number;
  value: any = null;
  value1: any = null;

  /**
   * Politics.
   */
  public politicsCiencuadras: string = 'https://www.ciencuadras.com/politicas-de-datos-personales';
  public politicsSegurosBolivar: string = '';
  public politicsDoctorAki: string = '';
  public politicsJeppit: string = 'https://www.jelpit.com/legal/politica-de-privacidad';

  /**
   * Terms.
   */
  public termsCiencuadras: string = 'https://www.ciencuadras.com/terminos-y-condiciones';
  public termsSegurosBolivar: string = '';
  public termsDoctorAki: string = '';
  public termsJeppit: string = 'https://www.jelpit.com/legal/terminos-y-condiciones';

  public documentTypes: any[] = [
    { label: 'Cédula de Ciudadanía', value: 'CC' },
    { label: 'Cédula de Extranjería', value: 'CE' },
    { label: 'Nit', value: 'NIT' },
  ];

  public channelTypes: any[] = [
    { label: 'Canal favorito: Correo', value: '1' },
    { label: 'Canal favorito: Llamada', value: '2' }
  ]
  public priorityLlamadaCobranza: number = 1;
  public priorityCorreoCobranza: number = 2;

  public visibleMyDataPermission: boolean = false;
  public visibleMyDataPermissionServicios: boolean = false;
  public visibleAuth: boolean = false;
  public visibleSaveNotification: boolean = false;
  public visibleErrorNotification: boolean = false;
  public visibleDataAuthorizationTreatment: boolean = false;

  myUrl: string = '';

  /**
   * Errors of form
  */
  errorDocumentNumber: boolean = false;
  errorDocumentType: boolean = false;
  errorChannel: boolean = false;
  errorName: boolean = false;
  errorLastName: boolean = false;
  errorEmail: boolean = false;
  errorPhone: boolean = false;

  errorNDocumentNumber: string = '';
  errorNDocumentType: string = '';
  errorNChannel: string = '';
  errorNName: string = '';
  errorNLastName: string = '';
  errorNEmail: string = '';
  errorNPhone: string = '';

  /**
   * Placeholders
  */
  phName: string = '';
  phLastName: string = '';
  phDocumentNumber: string = '';
  phEmail: string = '';
  phPhone: string = '';
  phChannel: string = '';

  /**
   * Labels
  */
  lName: string = '';
  lLastName: string = '';
  lDocumentNumber: string = '';
  lDocumentType: string = '';
  lEmail: string = '';
  lPhone: string = '';
  lChannel: string = '';

  slName: boolean = false;
  slLastName: boolean = false;
  slDocumentNumber: boolean = false;
  slDocumentType: boolean = false;
  slEmail: boolean = false;
  slPhone: boolean = false;
  slChannel: boolean = false;

  complementaryChannel: any = null;
  saveImage: string = '';
  errorImage: string = '';

  modelByBusiness: any[];

  constructor(
    private formService: FormService,
    private ipService: IpService,
    private formBuilder: FormBuilder
  ) {
    this.form = this.formBuilder.group({
      name: ['', Validators.required],
      lastName: ['', Validators.required],
      documentType: ['', Validators.required],
      channelType: ['', Validators.required],
      documentNumber: [null, Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: [null, Validators.required],
      email_contact: [true],
      call_contact: [true],
      sms_contact: [true],
      whatsapp_contact: [true],
      politics: [false, Validators.required],
      terms: [false, Validators.required]
    });

    this.customClass = '';
    this.customErrorNotificaction = '';
    this.customAuth = '';
    this.customSaveNotification = '';

    this.lineBusiness = 4;
    this.company = 3;
    this.modelByBusiness = [];
  }

  /**
   * Starts parameters.
   */
  ngOnInit(): void {
    this.myUrl = window.location.href;
    const data = this.ipService.getDomains();
    if (data) {
      this.modelByBusiness = data;
      this.asssingBusinessLine();
    }
    this.form.get('name').valueChanges.subscribe((value) => {
      this.changePage(value, 'name')
      if (this.domain === 'ciencuadras' || this.domain === 'jelpit' || this.domain === 'doctoraki') {
        this.slName = true;
      }
    });

    this.form.get('lastName').valueChanges.subscribe((value) => {
      this.changePage(value, 'lastName')
      if (this.domain === 'ciencuadras' || this.domain === 'jelpit' || this.domain === 'doctoraki') {
        this.slLastName = true;
      }
    });

    this.form.get('email').valueChanges.subscribe((value) => {
      this.changePage(value, 'email')
      if (this.domain === 'ciencuadras' || this.domain === 'jelpit' || this.domain === 'doctoraki') {
        this.slEmail = true;
      }
    });

    this.form.get('phone').valueChanges.subscribe((value) => {
      this.changePage(value, 'phone')
      if (this.domain === 'ciencuadras' || this.domain === 'jelpit' || this.domain === 'doctoraki') {
        this.slPhone = true;
      }
    });

    this.form.get('channelType').valueChanges.subscribe((value) => {
      if (this.domain === 'ciencuadras' || this.domain === 'jelpit' || this.domain === 'doctoraki') {
        this.slChannel = true;
      }
    });
  }

  public changePage(event: any, field: string): void {
    if (field === 'documentNumber') {
      const value = String(event ?? '');

      this.errorDocumentNumber = value.length < 5;

      if (this.domain === 'ciencuadras' || this.domain === 'jelpit' || this.domain === 'doctoraki') {
        this.slDocumentNumber = true;
      }
    }

    if (field === 'name') {
      const value = String(event ?? '');
      this.errorName = value.length === 0;
      this.validateInputText(value, 'name');
    }

    if (field === 'lastName') {
      const value = String(event ?? '');
      this.errorLastName = value.length === 0;
      this.validateInputText(value, 'lastName');
    }

    if (field === 'email') {
      const value = String(event ?? '');
      this.errorEmail = this.isValidEmail(value);
    }

    if (field === 'phone') {
      const value = String(event ?? '');
      const phone = this.removeHyphensAndUnderscores(value);
      this.errorPhone = !(phone.length === 10 && this.startsWithThree(phone));
    }
  }

  public validateInputText(value: string, nameInput: string): void {
    const validation = /^[A-Za-z\s]+$/.test(value);

    if (value.length === 0) {
      this.assignErrorByBusiness(nameInput);
    }

    if (!validation && value.length > 0) {
      if (nameInput === 'name') {
        this.errorName = true;
        this.errorNName = 'No se permiten caracteres especiales y números.'
      }

      if (nameInput === 'lastName') {
        this.errorLastName = true;
        this.errorNLastName = 'No se permiten caracteres especiales y números.'
      }
    }
  }

  public assignErrorByBusiness(type: string): void {
    const dataDomain = this.modelByBusiness.find((business: any) => business.domain === this.domain);

    this.errorNName = dataDomain.errorFields.find((field: any) => field.name === 'name').value;
    this.errorNLastName = dataDomain.errorFields.find((field: any) => field.name === 'lastName').value;
  }

  public isValidEmail(email: string): boolean {
    return !this.validateAttributesEmail(email);
  }

  public showDialogMyDataPermission() {
    this.visibleMyDataPermission = true;
  }

  public showDialogMyDataPermissionServicios() {
    this.visibleMyDataPermissionServicios = true;
  }

  public showDialogAuth() {
    this.visibleAuth = true;
  }

  public showDialogDataAuthorizationTreatment() {
    this.visibleDataAuthorizationTreatment = true;
  }

  public startsWithThree(input: string): boolean {
    const regex = /^3/;
    return regex.test(input);
  }

  public removeHyphensAndUnderscores(input: string): string {
    return input?.replace(/[-_]/g, '');
  }

  public validateAttributesEmail(correo: string): boolean {
    // Verifica que haya exactamente un símbolo @
    const partes = correo.split('@');
    if (partes.length !== 2) {
      return false;
    }

    const [parteLocal, dominio] = partes;

    // Verifica que la parte local y el dominio no estén vacíos
    if (!parteLocal || !dominio) {
      return false;
    }

    // Verifica que el dominio contenga al menos un punto .
    const dominioPartes = dominio.split('.');
    if (dominioPartes.length < 2) {
      return false;
    }

    // Verifica que haya caracteres antes y después del punto
    for (const parte of dominioPartes) {
      if (!parte) {
        return false;
      }
    }

    return true;
  }

  /**
   * Assigns business line.
   */
  public asssingBusinessLine(): void {
    const url: string = this.myUrl;
    let event = {
      target: {
        value: 'seguros-bolivar'
      }
    };

    if (url.includes('ciencuadras')) {
      event.target.value = 'ciencuadras';
      this.onChange(event);
    } else if (url.includes('aki')) {
      event.target.value = 'doctoraki';
      this.onChange(event);
    } else if (url.includes('segurosbolivar')) {
      event.target.value = 'seguros-bolivar';
      this.onChange(event);
    } else if (url.includes('jelpit')) {
      event.target.value = 'jelpit';
      this.onChange(event);
    } else if (url.includes('serviciosbolivar')) {
      event.target.value = 'servicios-bolivar';
      this.onChange(event);
    } else {
      event.target.value = 'ciencuadras';
      this.onChange(event);
    }
  }

  /**
   * Changes business.
  */
  public onChange(event: any): void {
    this.domain = event.target.value;
    document.body.className = this.domain;

    this.customClass = this.domain;

    const model = this.modelByBusiness.find((item: any) => item.domain === this.domain);

    this.errorNDocumentNumber = (model.errorFields.find((field: any) => field.name === 'documentNumber')).value;
    this.errorNDocumentType = (model.errorFields.find((field: any) => field.name === 'documentType')).value;
    this.errorNChannel = (model.errorFields.find((field: any) => field.name === 'channel')).value;
    this.errorNName = (model.errorFields.find((field: any) => field.name === 'name')).value;
    this.errorNLastName = (model.errorFields.find((field: any) => field.name === 'lastName')).value;
    this.errorNEmail = (model.errorFields.find((field: any) => field.name === 'email')).value;
    this.errorNPhone = (model.errorFields.find((field: any) => field.name === 'phone')).value;

    this.phName = (model.placeholderFields.find((field: any) => field.name === 'name')).value;
    this.phLastName = (model.placeholderFields.find((field: any) => field.name === 'lastName')).value;
    this.phDocumentNumber = (model.placeholderFields.find((field: any) => field.name === 'documentNumber')).value;
    this.phEmail = (model.placeholderFields.find((field: any) => field.name === 'email')).value;
    this.phPhone = (model.placeholderFields.find((field: any) => field.name === 'phone')).value;
    this.phChannel = (model.placeholderFields.find((field: any) => field.name === 'channel')).value;

    this.lName = (model.labelFields.find((field: any) => field.name === 'name')).value;
    this.lLastName = (model.labelFields.find((field: any) => field.name === 'lastName')).value;
    this.lDocumentType = (model.labelFields.find((field: any) => field.name === 'documentType')).value;
    this.lDocumentNumber = (model.labelFields.find((field: any) => field.name === 'documentNumber')).value;
    this.lEmail = (model.labelFields.find((field: any) => field.name === 'email')).value;
    this.lPhone = (model.labelFields.find((field: any) => field.name === 'phone')).value;
    this.lChannel = (model.labelFields.find((field: any) => field.name === 'channel')).value;

    this.company = model.company;
    this.lineBusiness = model.lineBusiness;

    if (this.domain === 'ciencuadras') {
      this.customSaveNotification = 'sn-ciencuadras';
      this.customErrorNotificaction = 'en-ciencuadras';
      this.customAuth = 'au-ciencuadras';

      this.slDocumentType = true;

      this.documentTypes = [
        { label: 'Cédula de Ciudadanía', value: 'CC' },
        { label: 'Cédula de Extranjería', value: 'CE' },
        { label: 'Nit', value: 'NIT' },
      ];

      this.form.patchValue({
        documentType: { label: 'Cédula de Ciudadanía', value: 'CC' }
      })
    }

    if (this.domain === 'seguros-bolivar') {
      this.saveImage = 'assets/images/save-icon-seguros.jpeg';
      this.errorImage = 'assets/images/error-icon-seguros.jpeg';

      this.customSaveNotification = 'sn-seguros-bolivar';
      this.customErrorNotificaction = 'en-seguros-bolivar';
      this.customAuth = 'au-seguros-bolivar';

      this.documentTypes = [
        { label: 'C.C', value: 'CC' },
        { label: 'C.E', value: 'CE' },
        { label: 'Nit', value: 'NIT' },
      ];

      this.form.patchValue({
        documentType: { label: 'C.C', value: 'CC' }
      })

      this.slName = true;
      this.slLastName = true;
      this.slDocumentNumber = true;
      this.slEmail = true;
      this.slPhone = true;
      this.slChannel = false;
      this.slDocumentType = true;
    }

    if (this.domain === 'servicios-bolivar') {
      this.saveImage = 'assets/images/save-icon-seguros.jpeg';
      this.errorImage = 'assets/images/error-icon-seguros.jpeg';

      this.customSaveNotification = 'sn-seguros-bolivar';
      this.customErrorNotificaction = 'en-seguros-bolivar';
      this.customAuth = 'au-seguros-bolivar';

      this.documentTypes = [
        { label: 'C.C', value: 'CC' },
        { label: 'C.E', value: 'CE' },
        { label: 'Nit', value: 'NIT' },
      ];

      this.form.patchValue({
        documentType: { label: 'C.C', value: 'CC' }
      })

      this.slName = true;
      this.slLastName = true;
      this.slDocumentNumber = true;
      this.slEmail = true;
      this.slPhone = true;
      this.slChannel = false;
      this.slDocumentType = true;
    }

    if (this.domain === 'doctoraki') {
      this.saveImage = 'assets/images/save-icon-seguros.jpeg';
      this.errorImage = 'assets/images/error-icon-seguros.jpeg';

      this.customSaveNotification = 'sn-doctoraki';
      this.customErrorNotificaction = 'en-doctoraki';
      this.customAuth = 'au-seguros-bolivar';

      this.documentTypes = [
        { label: 'Cédula de Ciudadanía', value: 'CC' },
        { label: 'Cédula de Extranjería', value: 'CE' },
        { label: 'Nit', value: 'NIT' },
      ];

      this.form.patchValue({
        documentType: null
      })
    }

    if (this.domain === 'jelpit') {
      this.saveImage = 'assets/images/save-icon-jelpit.jpeg';
      this.errorImage = 'assets/images/error-icon-jelpit.jpeg';

      this.customSaveNotification = 'sn-jelpit';
      this.customErrorNotificaction = 'en-jelpit';
      this.customAuth = 'au-jelpit';

      this.documentTypes = [
        { label: 'Cédula de Ciudadanía', value: 'CC' },
        { label: 'Cédula de Extranjería', value: 'CE' },
        { label: 'NIT', value: 'NIT' },
      ];
    }
  }

  public sendForm(): void {
    this.ipService.getIpAddress().subscribe((dataIp: any) => {
      const ipValue = dataIp.ip || dataIp["ip"] || dataIp;
      const body = {
        "nombre": this.form.value.name,
        "apellido": this.form.value.lastName,
        "correo": this.form.value.email,
        "numeroCelular": String(this.removeHyphensAndUnderscores(this.form.value.phone)),
        "tipoDocumento": this.form.value.documentType.value,
        "numeroDocumento": String(this.form.value.documentNumber),
        "correoComercial": this.form.value.email_contact,
        "llamadaComercial": this.form.value.call_contact,
        "mensajeComercial": this.form.value.sms_contact,
        "whatsappComercial": this.form.value.whatsapp_contact,
        "ip": ipValue,
        "llamadaCobranza": this.priorityLlamadaCobranza,
        "correoCobranza": this.priorityCorreoCobranza,
        "tratamientoDatos": this.form.value.politics,
        "autorizacionUtilizacionDatos": this.form.value.terms,
        "compania": this.company,
        "lineaNegocio": this.lineBusiness
      };

      this.formService.sendForm(body).subscribe({
        next: (data: any) => {
          if (data.statusCode === 200) {
            this.visibleSaveNotification = true;
            this.cleanForm();
          } else {
            this.visibleErrorNotification = true;
          }
        },
        error: (error) => {
          console.error('❌ Error al enviar:', error);
          this.visibleErrorNotification = true;
        }
      });
    });
  }

  public cleanForm(): void {
    this.form.reset();
    this.errorName = false;
    this.errorLastName = false;
    this.errorDocumentType = false;
    this.errorDocumentNumber = false;
    this.errorEmail = false;
    this.errorChannel = false;
    this.errorPhone = false;

    this.complementaryChannel = null;

    this.form.patchValue({
      email_contact: true,
      call_contact: true,
      sms_contact: true,
      whatsapp_contact: true,
      terms: false
    })

    if (this.domain === 'seguros-bolivar') {
      this.form.patchValue({
        documentType: { label: 'C.C', value: 'CC' }
      })
    }

    if (this.domain === 'ciencuadras') {
      this.slLastName = false;
      this.slName = false;
      this.slChannel = false;
      this.slDocumentNumber = false;
      this.slEmail = false;
      this.slPhone = false;

      this.form.patchValue({
        documentType: { label: 'Cédula de Ciudadanía', value: 'CC' }
      })
    }

    if (this.domain === 'jelpit') {
      this.slLastName = false;
      this.slName = false;
      this.slChannel = false;
      this.slDocumentNumber = false;
      this.slEmail = false;
      this.slPhone = false;
      this.slDocumentType = false;
    }

    if (this.domain === 'doctoraki') {
      this.slLastName = false;
      this.slName = false;
      this.slChannel = false;
      this.slDocumentNumber = false;
      this.slEmail = false;
      this.slPhone = false;
      this.slDocumentType = false;
    }
  }

  public selectChannelEvent(event: any): void {
    if (event.node.value === '1') {
      this.priorityCorreoCobranza = 1;
      this.priorityLlamadaCobranza = 2;
      this.complementaryChannel = 'Llamada'
    }

    if (event.node.value === '2') {
      this.priorityLlamadaCobranza = 1;
      this.priorityCorreoCobranza = 2;
      this.complementaryChannel = 'Correo'
    }
  }

  public validateForm(): boolean {
    const policies = this.form.value.politics;

    const contact_whatsapp = this.form.value.whatsapp_contact ? 1 : 0;
    const contact_call = this.form.value.call_contact ? 1 : 0;
    const contact_sms = this.form.value.sms_contact ? 1 : 0;
    const contact_email = this.form.value.email_contact ? 1 : 0;
    const reference = contact_call + contact_whatsapp + contact_sms + contact_email;

    const form = this.form.valid && !(this.errorDocumentNumber || this.errorEmail || this.errorLastName || this.errorName || this.errorPhone);

    return this.form.valid && policies && (reference > 1) && form;
  }

  public openPolicies(): void {
    if (this.domain === 'ciencuadras') {
      window.open('https://www.ciencuadras.com/politicas-de-datos-personales', '_blank', 'noopener');
    }

    if (this.domain === 'jelpit') {
      window.open('https://www.jelpit.com/conjuntos/politica-de-privacidad', '_blank', 'noopener');
    }

    if (this.domain === 'seguros-bolivar') {
      window.open('https://d9b6rardqz97a.cloudfront.net/wp-content/uploads/2024/02/16112906/240213_transv_5335_15Feb24.pdf', '_blank', 'noopener');
    }

    if (this.domain === 'servicios-bolivar') {
      window.open('https://www.serviciosbolivar.com/politica-de-privacidad', '_blank', 'noopener');
    }
  }

  public openMyDataPermission(): void {
    if (this.domain === 'ciencuadras') {
      //window.open('https://www.ciencuadras.com/uso-datos-personales', '_blank','noopener');
      this.showDialogMyDataPermissionServicios();
    }

    if (this.domain === 'jelpit') {
      //window.open('https://www.jelpit.com/legal/autorizacion-de-datos', '_blank','noopener');
      this.showDialogMyDataPermissionServicios();
    }

    if (this.domain === 'seguros-bolivar') {
      this.showDialogMyDataPermission();
    }

    if (this.domain === 'servicios-bolivar') {
      this.showDialogMyDataPermissionServicios();
    }
  }

  public openAuth(): void {
    this.showDialogAuth();
  }

  public openDataAuthorizationTreatment(): void {
    if (this.domain === 'seguros-bolivar') {
      this.showDialogDataAuthorizationTreatment();
    }
  }

  hasError(value: string) {
    const input = this.form.get(value).value;

    if (value === 'documentType') {
      this.errorDocumentType = !input;
      this.slDocumentType = true;
    }

    if (value === 'channelType') {
      this.errorChannel = !input;
      this.slChannel = true;
    }
  }
}